export default {
    getHeaders(template) {
        return DMUtils.http({
            method: 'GET',
            url: '/Reports/GetByTemplateName',
            params: { TemplateName: template },
        });
    },
    updateHeaders(dto) {
        return DMUtils.http({
            method: 'POST',
            url: '/Reports/CreateOrUpdate',
            data: dto,
        });
    },
    getReportSettings() {
        return DMUtils.http({
            method: 'GET',
            url: '/Reports/GetReportSettings',
        });
    },
    updateReportSettings(dto) {
        return DMUtils.http({
            method: 'POST',
            url: '/Reports/UpdateReportSettings',
            data: dto,
        });
    },
    getAdditionalReports(sessionID) {
        return DMUtils.http({
            method: 'GET',
            url: '/Reports/GetAllAdditionalReportsForSession',
            params: {SessionID: sessionID},
        });
    },
    downloadAddtionalReport(reportID) {
        return DMUtils.http({
            method: 'GET',
            url: '/Reports/DownloadAdditionalReport',
            params: {ReportID: reportID},
            returnsFile: true,
        });
    },
    createAdditionalReport(dto) {
        return DMUtils.http({
            method: 'POST',
            url: '/Reports/CreateAdditionalReport',
            data: dto,
        });
    },
    deleteAdditionalReport(dto) {
        let deleteDto = {
            ReportID: dto.ReportID,
            SessionID: dto.SessionID
        }
        return DMUtils.http({
            method: 'POST',
            url: '/Reports/DeleteAdditionalReport',
            data: deleteDto,
        });
    },
    getReportHeadersNameAndValue(sessionID) {
        return DMUtils.http({
            method: 'Get',
            url: '/Reports/GetReportHeadersNameAndValue',
            params: { SessionID: sessionID },
        });
    }
};
